import {ClipLoader} from "react-spinners";
import TopBar from "../../components/Layout/TopBar";
import MyButton from "../../components/Layout/MyButton";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {Modal, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import useAuthz from "../../hooks/useAuthz";
import {useAlert} from "react-alert";
import {useNavigate} from "react-router";
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import MySelect from "../../components/Layout/MySelect";

const css = {
	container: {height: '60%', width: '40%', backgroundColor: 'white', borderRadius: '5px'},
	fullRow: {height: '100%', width: '100%', alignItems: 'center'},
	row: {height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal'},
	rowValidation: {height: '60px', flexDirection: 'column', justifyContent: 'normal', alignItems: 'flex-end'},
	textField: {width: '50%', margin: '20px'},
	contractBtn: {
		color: 'rgb(255, 255, 255)',
		height: '50%',
		backgroundColor: '#0094CA',
		width: '20%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '10px',
		cursor: 'pointer',
	},
	contractBtnIcon: {fontSize: "50px"},
	contractBtnLabel: {
		textAlign: 'center',
		textDecoration: 'none',
		fontSize: 14,
		fontWeight: 700,
		margin: '10px',
		cursor: 'pointer'
	},
}

const ModalGenerateSapXmlDocument = (props) => {
	const {openModal, setOpenModal, setOpenModelDisplayDevisPdf, color, facturation_id, facturation, setReloadData} = props;
	const [authz, user, profil] = useAuthz();
	const alert = useAlert();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const [xmlData, setXmlData] = useState({
		partn: facturation.dossier.metadata.complementIdentite.tiers.numSap || '',
		payer: facturation.dossier.metadata.complementIdentite.tiers.numSapSubsidiary || '',
		bstkd: facturation.elements_factures.status.refCommande || '',
		headerText: null,
		name: null
	});

	useEffect(() => {
		apiGetBilledThirdPartyNumber(facturation.dossier.metadata.complementIdentite.tiers.numTva);
	}, [facturation])

	// region function
	const handleCloseModal = () => {
		setIsLoading(false);
		setOpenModal(false);
	};

	const handleChange = (e, pattern) => {
		if (e.target.value === '' || new RegExp(pattern).test(e.target.value)) {
			setXmlData({...xmlData, [e.target.name]: e.target.value});
		}
	};
	// endregion

	// region API
	const generateXmlSap = () => {
		if (!xmlData.name || xmlData.name === '') {
			alert.error("Société non renseignée");
			return;
		}
		axios({
			method: 'post',
			url: `${URL_API}/facturation/generer-xml-sap`,
			data: xmlData,
			params: {facturationId: facturation_id}
		})
			.then((response) => {
				alert.removeAll();
				setReloadData(true);
				if (response.data === false) {
					alert.error(`Le fichier SAP a déja été généré pour cette facturation`);
					return;
				} else if (!response.data) {
					alert.error(`Le fichier XML n'a pas été généré`);
					return;
				}
				alert.success(`Le ficher SAP a été sauvegardé`);
			})
			.catch((error) => {
				alert.removeAll();
				alert.error(error.message);
			})
	}

	const apiGetBilledThirdPartyNumber = (value) => {
		if (!value) {
			return false;
		}

		axios({
			method: 'GET',
			url: `${URL_API}/billed-third-party/get-by-tva`,
			params: {
				value: String(value),
			},
		})
		.then((response) => {
			alert.removeAll();

			let data = response.data;

			if (data) {
				setXmlData({
					...xmlData,
					partn: data.num_sap,
					payer: data.num_sap_subsidiary,
				})
			}

		})
		.catch((error) => {
			alert.removeAll();
			alert.error(error.message);
		});
	};
	// endregion

	return (<>
		<Modal open={openModal} style={{display: 'flex'}} disableEscapeKeyDown={true}>
			<div className='modal' style={{width: "110vw", height: "106vh", top: '-40px', left: '-100px'}}>
				{isLoading &&
				<div className='row' style={css.fullRow}>
					<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
				</div>}
				{!isLoading &&
				<div style={{...css.container, height: "40%"}}>
					<TopBar title={"Génération fichier XML"} className='topbar-contenu' color={'#f18d2d'}
									buttons={<div className='topbar-buttons'>
														<MyButton onClick={() => handleCloseModal()}
																			label="Fermer"
																  			sx={{backgroundColor: '#b76618 !important'}}
																			icon={faXmark}/>
													 </div>}
					/>
					<div style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						height: '70%',
						width: '100%'
					}}>
						<div className="row" style={{flexWrap: 'nowrap', justifyContent: 'left', maxHeight: '100px', width: '100%'}}>
							<TextField
								label="Code client SAP"
								type="text"
								name="partn"
								value={xmlData.partn || ''}
								style={css.textField}
								autoComplete="off"
								onChange={(e) => handleChange(e)}
								inputProps={{maxLength: 10}}
							/>
							<TextField
								label="Code client divergent"
								type="text"
								name="payer"
								value={xmlData.payer || ''}
								style={css.textField}
								autoComplete="off"
								onChange={(e) => handleChange(e)}
								inputProps={{maxLength: 10}}
							/>
						</div>
						<div className="row" style={{flexWrap: 'nowrap', justifyContent: 'left', maxHeight: '100px', width: '100%'}}>
							<TextField
								label="Référence commande client"
								type="text"
								name="bstkd"
								value={xmlData.bstkd || ''}
								style={css.textField}
								autoComplete="off"
								onChange={(e) => handleChange(e)}
							/>
							<TextField
								label="Texte d'entête"
								type="text"
								name="headerText"
								value={xmlData.headerText || ''}
								style={css.textField}
								autoComplete="off"
								onChange={(e) => handleChange(e)}
								inputProps={{maxLength: 70}}
							/>
						</div>
						<div className="row" style={{flexWrap: 'nowrap', justifyContent: 'left', maxHeight: '100px', width: '100%'}}>
							<MySelect name={"name"}
												label={"Société"}
												datas={[{key: "1042", value: "Sanef"},{key: "1052", value: "Sapn"}]}
												disableClass={true}
												displayLabel={true}
												noNull={false}
												value={xmlData.name || ''}
												firstValue={{key: "", value: "Choisissez le nom du fichier"}}
												style={{width: "382px"}}
												handleChange={(e) => handleChange(e)}
							/>
						</div>
					</div>
					<div className="row" style={{justifyContent: 'flex-end', alignItems: 'center', height: '80px'}}>
						<MyButton
							style={"buttonValidation"}
							label={"Générer le fichier"}
							onClick={generateXmlSap}
						/>
					</div>
				</div>}
			</div>
		</Modal>
	</>)
}

export default ModalGenerateSapXmlDocument
